import React from "react";
import { PublicShell } from "@/components/PublicNav";
import {
  QrCode, Smartphone, ShoppingCart, Settings, Image as ImageIcon, BarChart3, MessageSquare,
  MessageCircle, Star, UserCheck, RefreshCw, Award, Languages,
} from "lucide-react";

const items = [
  { icon: QrCode, t: "QR Code Generation", d: "Each restaurant gets a unique QR linking to its menu. Download a hi-res PNG instantly." },
  { icon: Smartphone, t: "Mobile-First Digital Menu", d: "Beautiful 430px-optimised menu page that works on every phone, no install required." },
  { icon: ShoppingCart, t: "Cart + Multi-Item WhatsApp Orders", d: "Customers add multiple items, then send a pre-formatted WhatsApp order to your kitchen." },
  { icon: Settings, t: "Easy Menu Management", d: "Categories, items, availability — all editable in seconds from the dashboard." },
  { icon: ImageIcon, t: "Image Uploads", d: "Cloudinary-powered uploads (mocked in this build) — auto-optimised for mobile." },
  { icon: BarChart3, t: "Analytics Dashboard", d: "QR scans, menu views, popular items and customer frequency, all in one place." },
  { icon: MessageSquare, t: "Customer Feedback CRM", d: "Capture every review with name, phone, star rating, message, date — filter by rating or date." },
  { icon: MessageCircle, t: "WhatsApp Ordering", d: "Pre-filled messages with item list, quantities, ₹ totals and customer info." },
  { icon: Star, t: "Google Review Integration", d: "One-tap link to your Google review page right from the menu." },
  { icon: UserCheck, t: "Account Manager", d: "Each restaurant gets a dedicated success manager assigned by the admin." },
  { icon: RefreshCw, t: "Real-Time Menu Updates", d: "Update prices or mark items out-of-stock instantly — customers see it live." },
  { icon: Award, t: "Loyalty Badge System", d: "Earn 5 badges via WhatsApp orders to unlock rewards you set — '10% off' or '1 free Lassi'." },
  { icon: Languages, t: "Multilanguage Menus", d: "Add translations in English, हिंदी, ગુજરાતી. Customers switch languages on the menu page." },
];

export const Features = () => (
  <PublicShell>
    <section className="zq-hero-bg">
      <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-20 text-center">
        <span className="zq-pill zq-pill-orange">Features</span>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4">Every tool. None of the bloat.</h1>
        <p className="text-zq-muted mt-5 max-w-2xl mx-auto">A focused feature set built around how Indian restaurants actually run their day.</p>
      </div>
    </section>
    <section className="zq-section">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((f, i) => (
          <div key={i} className="zq-card p-5" data-testid={`feature-${i}`}>
            <div className="w-10 h-10 rounded-md flex items-center justify-center bg-zq-orange-light text-zq-orange mb-3">
              <f.icon size={20} />
            </div>
            <h3 className="font-semibold">{f.t}</h3>
            <p className="text-sm text-zq-muted mt-1.5">{f.d}</p>
          </div>
        ))}
      </div>
    </section>
  </PublicShell>
);
